query getSubsidiesWithDeadlines($site: [String!], $deadlines: [QueryArgument!]) {
    entries(
        site: $site
        section: "subsidies"
        relatedTo: $deadlines
        #relatedToCategories: []
    ) {
        title
        ... on subsidy_Entry {
            uri
            periodsRelation (
                id: $deadlines
            ) {
                ... on default_Entry {
                    id
                }
            }
        }
    }
}
